import readXlsxFile from 'read-excel-file';
import React from 'react';
import { Container, Row, Spinner, Col, Button } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
const columns = [{ title: 'Order Files', field: 'fileName' }];

class SalesOrderNotification extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            selectedStoreTags: [],
            allSheets: [],
            flag: true,
            data: [],
            csvStatus: ''
        };
    }
    async componentDidMount() {
        this._isMounted = true;
        this.setState({ flag: false });
        if (this.props.role === 'Admin') {
            this.loadData();
        } else {
            this.loadOrderSheetsData();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadOrderSheetsData() {
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.loadOrderSheetsData(
            localStorage.getItem('FirebaseToken'),
            this.props.user.ProfileUniqeID
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                    this.setState({
                        allSheets: responseData,
                        flag: false,
                        alert: 0
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });

        
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.getStoreTagsOwners(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (this._isMounted) {
                    this.setState({ flag: false });
                }
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            data: responseData,
                            flag: false,
                            alert: 0
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    handleFileUploaded = async (event) => {
        let mapRecords = this.state.data;
        let mapRecordsFinal = [];
        let dataLabels = [];

        if (event.target.files.length > 0) {
            if (this._isMounted) {
                this.setState({
                    csvStatus:
                        'Reading File...Please wait. This process will took some  time.',
                    flag: true
                });
            }
            this.file = event.target.files[0];

            await readXlsxFile(this.file, 'Store Summary').then(
                async (sheetdata) => {
                    
                    dataLabels = sheetdata[0];

                    await sheetdata.forEach(async (sheetvalue) => {
                        let StoreTag = sheetvalue[2];
                        mapRecords.some(function (el) {
                            if (el.StoreTag === StoreTag) {
                                el.data = sheetvalue;
                            }
                        });
                    });
                }
            );
            if (this._isMounted) {
                this.setState({ csvStatus: 'Parsing File...' });
            }
            await mapRecords.forEach(async (sheetvalue) => {
                if (sheetvalue.data.length > 0) {
                    let dataList = sheetvalue.data;
                    let StoreOwner = sheetvalue.StoreOwner;

                    if (
                        mapRecordsFinal.some(
                            (item) => StoreOwner === item.StoreOwner
                        )
                    ) {
                        mapRecordsFinal.some(function (el) {
                            if (el.StoreOwner === StoreOwner) {
                                el.DataList.push(dataList);
                            }
                        });
                    } else {
                        mapRecordsFinal.push({
                            StoreOwner: StoreOwner,
                            StoreOwnerName: sheetvalue.StoreOwnerName,
                            dataLabels: dataLabels,
                            DataList: [dataList]
                        });
                    }
                }
            });

            let k = 0;
            await mapRecordsFinal.forEach(async (finalShrret) => {
                k++;
                if (this._isMounted) {
                    this.setState({
                        csvStatus:
                            'Message sent to ' +
                            k +
                            ' Store Owner out of ' +
                            mapRecordsFinal.length +
                            ' Store Owners'
                    });
                }

                await RestServices.createOrderCSV(
                    localStorage.getItem('FirebaseToken'),
                    finalShrret
                )
                    .then((response) => response.json())
                    .then((responseData) => {
                        
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: err.message
                            });
                        }
                    });
            });
            if (this._isMounted) {
                this.setState({ flag: false });
            }
        }
    };

    DownloadTemplate = () => {
        window.open('/SampleOrders.xlsx');
    };

    render() {
        const actions = [
            {
                icon: 'preview',
                tooltip: 'Download CSV',
                onClick: (event, rowData) => {
                    window.open(
                        RestServices.getServerBaseURL() +
                            'download/csv/?name=' +
                            rowData.fileName
                    );
                    //if(this._isMounted) { this.setState({showAddEdit:true,selectedRow:rowData})}
                }
            }
        ];
        return (
            <Container>
                {this.state.flag && <Spinner animation="border" />}

                <Row>
                    <h5 style={{ marginLeft: '1rem' }}>
                        Sales Order Notification
                    </h5>
                </Row>
                <div>
                    <hr />
                </div>

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 2 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.props.role != 'Admin' && this.state.allSheets && (
                    <MaterialTable
                        components={{
                            Pagination: PatchedPagination
                        }}
                        title="CSV Files"
                        columns={columns}
                        data={this.state.allSheets}
                        actions={actions}
                        options={{
                            filtering: true,
                            actionsColumnIndex: -1,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                    />
                )}

                {this.state.data.length > 0 && (
                    <div>
                        <Row>
                            <Col style={{ textAlign: 'center' }}>
                                <Tooltip title="Upload File">
                                    <IconButton aria-label="upload">
                                        <label>
                                            <CloudUploadIcon />
                                            <input
                                                type="file"
                                                hidden
                                                id="custom-file-translate"
                                                lang="en"
                                                accept=".xlsx, .xls,"
                                                onChange={
                                                    this.handleFileUploaded
                                                }
                                            />
                                        </label>
                                    </IconButton>
                                </Tooltip>
                            </Col>
                        </Row>

                        <Row>
                            <Col style={{ textAlign: 'center' }}>
                                Upload Order sheet(.xlsx OR .xls)
                            </Col>
                        </Row>

                        <Row>
                            <Col style={{ textAlign: 'center' }}>
                                <Button
                                    style={{ marginTop: '1rem' }}
                                    variant="info"
                                    type="submit"
                                    onClick={this.DownloadTemplate}
                                >
                                    Download Template
                                </Button>
                            </Col>
                        </Row>
                    </div>
                )}

                {this.state.csvStatus && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.csvStatus}
                            </Alert>
                        </Col>
                    </Row>
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(SalesOrderNotification);
